<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch2">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch2.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-2">“Are you <em class="italic">sure</em> your mom works for Dr. Eeek?” the receptionist grills you. She raises an eyebrow.</a></p><a id="pg-2">
<p class="para" style="text-indent: 5%;">Her eyebrows give you the creeps.</p>
<p class="para" style="text-indent: 5%;">In fact, this whole place gives you the creeps.</p>
<p class="para" style="text-indent: 5%;">From the minute you stepped off the elevator on the nineteenth floor, there were no signs of life. No one in the echoing hall. Nothing but the creaking elevator door.</p>
<p class="para" style="text-indent: 5%;">And then you spotted the door to Eeek Labs. Your mother never told you about that, either. The door looked like the door to a huge <em class="italic">vault</em>! It was heavy steel — and about six inches thick.</p>
<p class="para" style="text-indent: 5%;">Your best friend, Sam, pulled a small handle near the edge of the door. To your surprise, the door swung open easily.</p>
<p class="para" style="text-indent: 5%;">Okay, you told yourself. So the place has a weird door. That’s no reason to freak out.</p>
<p class="para" style="text-indent: 5%;">“Yeah, she works here,” you tell the receptionist. “She does research.”</p>
<p class="para" style="text-indent: 5%;">“Well, take a seat,” she replies. “I’m sure your mom will be right here.” Then she packs up her oversized tote bag and walks out.</p>
<p class="para" style="text-indent: 5%;">You search around for a chair. Then you see them. Across the room. The chairs are all orange plastic — and they’re all chained together!</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-2"><em class="italic">Sit down on</em> </a><a href="#/e9780545841054_ch003"><em class="italic">PAGE 3</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841054_ch002.vue?30a70fac